export default __webpack_public_path__ + "static/media/promo-2.ec353db9.png";